import React from 'react';
import LogoSM from './../../../public/Images/logosm.png'

function Menu(){
    return( 
    <nav className="navbar fixed-top navbar-expand-md navbar-dark">

      <div className="container-fluid">
        <a aria-current="page" href={"https://www.redesupermarket.com.br/"}>
        <img  className="logosm" src="https://redesupermarket.com.br/wp-content/uploads/2025/12/logo-150-cor.png" alt="Rede Supermarket" title="Rede Supermarket" />
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" aria-current="page" href="#footer"></a>
            </li>
            <li className="nav-item">
              <a className="nav-link" aria-current="page" href="#footer"></a>
            </li>
            <li className="nav-item">
            <a className="nav-link" aria-current="page" href="https://www.redesupermarket.com.br/"><i className="bi bi-cart"> Supermarket</i></a>
            </li>
            {/*<li className="nav-item">
              <a className="nav-link" aria-current="page" href="#features"><i class="fa fa-list" aria-hidden="true"></i> Acessos</a>
            </li>*/}
            {/*<li className="nav-item">
              <a className="nav-link" aria-current="page" href="#testemunho"><i className="fa fa-birthday-cake" aria-hidden="true"></i> Aniversariantes</a>
            </li>*/}
            <li className="nav-item">
              <a className="nav-link" aria-current="page" href="#preco"><i className="fa fa-play" aria-hidden="true"></i> Videos</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" aria-current="page" href="#footer"><i className="fa fa-info" aria-hidden="true"></i> Contatos</a>
            </li>
          </ul>
        </div>    
      
    </div>
  </nav>
    )
  }

export default Menu;